import { useState } from 'react'
import { apiUrl } from '../lib/api'

const ROLES = [
  { id: 'bar', label: 'Bar / kiosek' },
  { id: 'kuchyne', label: 'Kuchyně / pomoc' },
  { id: 'pokladna', label: 'Pokladna' },
  { id: 'uklid', label: 'Úklid pokojů' },
]

export function Brigady() {
  const [form, setForm] = useState({
    name: '', phone: '', email: '', role: 'bar', note: '',
    // Volitelné DPP údaje
    birth_date: '', birth_number: '',
    address_street: '', address_city: '', address_zip: '',
    bank_account: '', health_insurance: '',
  })
  const [showDpp, setShowDpp] = useState(false)
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [err, setErr] = useState<string | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setErr(null)
    try {
      // Rozdělit "name" na first_name + last_name pro backend
      const parts = form.name.trim().split(/\s+/)
      const first_name = parts[0] || ''
      const last_name = parts.slice(1).join(' ') || ''
      const payload: any = {
        first_name, last_name,
        phone: form.phone,
        email: form.email || undefined,
        role: form.role,
        note: form.note || undefined,
      }
      // Volitelné DPP pole — jen co je vyplněné
      ;['birth_date', 'birth_number', 'address_street', 'address_city',
        'address_zip', 'bank_account', 'health_insurance'].forEach((k) => {
        const v = (form as any)[k]
        if (v) payload[k] = v
      })
      const r = await fetch(apiUrl('/api/sobacov/recruit/public'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      if (!r.ok) throw new Error('Nepodařilo se odeslat')
      setDone(true)
    } catch (e: any) {
      setErr(e.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <section id="brigady" className="py-20 md:py-28 bg-steel-800 text-white">
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <p className="h-eyebrow text-white/60">Brigády</p>
            <h2 className="font-extrabold text-3xl md:text-[44px] mt-4 leading-[1.06] tracking-[-0.025em]" style={{ textWrap: 'balance' }}>
              Přidej se k&nbsp;nám na letní <span className="h-accent">sezónu</span>
            </h2>
            <p className="mt-6 text-white/85 text-lg leading-relaxed">
              Hledáme brigádníky na sezónu květen–září: kiosek, kuchyně, pokladna, úklid.
              Vlastní mobilní appka pro docházku, úkoly a&nbsp;výplatu.
            </p>
            <ul className="mt-7 space-y-2.5">
              {[
                'Plat 130–180 Kč/h dle pozice',
                'Mobilní appka pro docházku, výplatu, úkoly',
                'Sezónní bonus pro celosezónní brigádníky',
              ].map((b) => (
                <li key={b} className="flex items-start gap-2.5">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 mt-1 shrink-0 text-brand-400" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 12.5l5 5L20 6.5" />
                  </svg>
                  <span className="text-white/90">{b}</span>
                </li>
              ))}
            </ul>
          </div>

          <form onSubmit={submit} className="bg-white text-ink-800 p-7 md:p-9 rounded-2xl">
            {done ? (
              <div className="text-center py-10">
                <svg viewBox="0 0 24 24" className="w-12 h-12 mx-auto mb-3 text-brand-500" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 12.5l5 5L20 6.5" />
                </svg>
                <div className="font-semibold text-xl text-ink-900">Děkujeme!</div>
                <p className="text-ink-700 mt-2 text-sm">Provozní Gabi se ti ozve do 48 h.</p>
              </div>
            ) : (
              <>
                <h3 className="font-bold text-lg text-ink-900 tracking-tight">Mám zájem o&nbsp;brigádu</h3>
                <div className="grid sm:grid-cols-2 gap-4 mt-4">
                  <Field label="Jméno a příjmení *" value={form.name} onChange={(v) => setForm({ ...form, name: v })} required />
                  <Field label="Telefon *" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} required />
                </div>
                <label className="block mt-4">
                  <span className="text-[11px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">Pozice</span>
                  <select
                    value={form.role}
                    onChange={(e) => setForm({ ...form, role: e.target.value })}
                    className="mt-1.5 w-full border border-ink-900/15 rounded-lg px-3 py-2 text-ink-800 focus:outline-none focus:border-brand-500"
                  >
                    {ROLES.map((r) => (
                      <option key={r.id} value={r.id}>
                        {r.label}
                      </option>
                    ))}
                  </select>
                </label>
                <div className="mt-4">
                  <Field label="E-mail" value={form.email} onChange={(v) => setForm({ ...form, email: v })} />
                </div>
                <label className="block mt-4">
                  <span className="text-[11px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">Poznámka</span>
                  <textarea
                    value={form.note}
                    onChange={(e) => setForm({ ...form, note: e.target.value })}
                    rows={3}
                    placeholder="Kdy můžeš, věk, předchozí zkušenosti…"
                    className="mt-1.5 w-full border border-ink-900/15 rounded-lg px-3 py-2 text-ink-800 focus:outline-none focus:border-brand-500"
                  />
                </label>

                {/* Volitelná sekce: údaje pro Dohodu o provedení práce */}
                <button
                  type="button"
                  onClick={() => setShowDpp(!showDpp)}
                  className="mt-5 w-full text-left border border-ink-900/15 rounded-lg px-3 py-2.5 bg-ink-50 hover:bg-ink-100 transition flex items-center justify-between"
                >
                  <div>
                    <div className="text-[11px] uppercase tracking-[0.16em] text-ink-800 font-semibold">Údaje pro smlouvu (volitelné)</div>
                    <div className="text-[11px] text-ink-700 mt-0.5">
                      Pokud vyplníš teď, urychlíš zpracování brigády
                    </div>
                  </div>
                  <svg viewBox="0 0 24 24" className={`w-4 h-4 text-ink-700 transition-transform ${showDpp ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>

                {showDpp && (
                  <div className="border border-t-0 border-ink-900/15 rounded-b-lg bg-ink-50/50 p-3 space-y-3">
                    <p className="text-[11px] text-ink-700 leading-snug">
                      Tyhle údaje jdou rovnou do Dohody o provedení práce. Nemusíš je vyplňovat hned — můžeš až
                      po nástupu. Vše je důvěrné, vidí jen mzdová účtárna.
                    </p>
                    <div className="grid grid-cols-2 gap-2">
                      <Field2 label="Datum narození" type="date"
                        value={form.birth_date} onChange={(v) => setForm({ ...form, birth_date: v })} />
                      <Field2 label="Rodné číslo (bez /)"
                        value={form.birth_number} onChange={(v) => setForm({ ...form, birth_number: v })}
                        placeholder="020315123" />
                    </div>
                    <Field2 label="Ulice + č.p."
                      value={form.address_street} onChange={(v) => setForm({ ...form, address_street: v })}
                      placeholder="Hlavní 42" />
                    <div className="grid grid-cols-2 gap-2">
                      <Field2 label="Město"
                        value={form.address_city} onChange={(v) => setForm({ ...form, address_city: v })} />
                      <Field2 label="PSČ"
                        value={form.address_zip} onChange={(v) => setForm({ ...form, address_zip: v })}
                        placeholder="779 00" />
                    </div>
                    <Field2 label="Bankovní účet (pro výplatu)"
                      value={form.bank_account} onChange={(v) => setForm({ ...form, bank_account: v })}
                      placeholder="123456789/0100" />
                    <Field2 label="Zdravotní pojišťovna (kód)"
                      value={form.health_insurance} onChange={(v) => setForm({ ...form, health_insurance: v })}
                      placeholder="111 (VZP), 201, 205…" />
                  </div>
                )}

                {err && <div className="mt-3 text-brand-500 text-sm">{err}</div>}
                <button type="submit" disabled={busy} className="btn-book w-full mt-5">
                  {busy ? 'Odesílám…' : 'Odeslat přihlášku'}
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </section>
  )
}

function Field({
  label,
  value,
  onChange,
  required,
}: {
  label: string
  value: string
  onChange: (v: string) => void
  required?: boolean
}) {
  return (
    <label className="block">
      <span className="text-[11px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">{label}</span>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="mt-1.5 w-full border border-ink-900/15 rounded-lg px-3 py-2 text-ink-800 focus:outline-none focus:border-brand-500"
      />
    </label>
  )
}

function Field2({
  label, value, onChange, type = 'text', placeholder,
}: {
  label: string; value: string; onChange: (v: string) => void
  type?: string; placeholder?: string
}) {
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-[0.12em] text-ink-700/70 font-semibold">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="mt-1 w-full border border-ink-900/15 rounded-lg px-2.5 py-1.5 text-ink-800 text-sm focus:outline-none focus:border-brand-500"
      />
    </label>
  )
}
